import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import PreLoginContainer from "../../common/preLoginContainer";
import Link from "../../common/link";
import { Field } from "react-final-form";
import { TextInput, Checkbox } from "../../common/fields";
import Form from "../../common/form";
import * as Validations from "../../common/form/validator";
import { RouteConstants } from "../../../constants";
import {
  resetState,
  resetPasswordRequest,
} from "../../../store/slices/authSlice";
import { useEffect, useState } from "react";

const SetPassword = ({
  action,
  error,
  requesting,
  resetState,
  resetPasswordRequest,
}) => {
  const intl = useIntl();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [isPasswordReset, setIsPasswordReset] = useState(false);

  useEffect(() => {
    resetState();
  }, [resetState]);

  useEffect(() => {
    if (action === "reset-password" && !requesting && !error) {
      setIsPasswordReset(true);
    }
  }, [action, requesting, error, setIsPasswordReset]);

  const userName =
    (searchParams.get("params") &&
      atob(decodeURIComponent(searchParams.get("params")))) ||
    null;

  return (
    <PreLoginContainer>
      <div className="title text-center">
        {intl.formatMessage({ id: "reset_password" })}
      </div>
      {(!isPasswordReset && (
        <>
          <div className="tag-line text-muted">
            {intl.formatMessage({ id: "reset_password_message" })}
          </div>
          <Form
            initialValues={{
              username: userName,
            }}
            requesting={action === "reset-password" && requesting}
            fullWidthButtons
            submitBtn={{
              label: intl.formatMessage({ id: "reset_password" }),
              icon: "pi-arrow-right",
              onClick: (values) => {
                if (values.rememberMe) {
                  Cookies.set("username", values.username, {
                    expires: 30,
                    secure: true,
                    sameSite: "Strict",
                  });
                }
                resetPasswordRequest({
                  token: params.token,
                  password: values.newPassword,
                });
              },
            }}
          >
            <div className="flex flex-column gap-2 mt-4">
              {(userName && (
                <Field
                  name="username"
                  component={TextInput}
                  label={intl.formatMessage({
                    id: "username",
                  })}
                  readOnly
                  type="text"
                  icon="pi-user"
                  placeholder={intl.formatMessage({
                    id: "username",
                  })}
                />
              )) ||
                null}
              <Field
                name="newPassword"
                component={TextInput}
                showPasswordFeedback
                type="password"
                label={intl.formatMessage(
                  { id: "dynamic_password" },
                  { label: "New" }
                )}
                placeholder={intl.formatMessage(
                  { id: "dynamic_password" },
                  { label: "New" }
                )}
                required
                validate={Validations.composeValidators(Validations.required)}
              />
              <Field
                name="confPassword"
                component={TextInput}
                type="password"
                showPasswordFeedback
                label={intl.formatMessage(
                  { id: "dynamic_password" },
                  { label: "Confirm New" }
                )}
                placeholder={intl.formatMessage(
                  { id: "dynamic_password" },
                  { label: "Confirm New" }
                )}
                required
                validate={Validations.composeValidators(
                  Validations.required,
                  Validations.checkConfirmPassword
                )}
              />
              <div className="mt-2">
                <Field
                  name="rememberMe"
                  component={Checkbox}
                  type="checkbox"
                  label={intl.formatMessage({ id: "remember_me" })}
                />
              </div>
            </div>
            {(error && !requesting && action === "reset-password" && (
              <div className="error-message">
                {intl.formatMessage({
                  id: (error?.response || "unknown_error").toLowerCase(),
                })}
              </div>
            )) ||
              null}
          </Form>
        </>
      )) || (
        <div className="tag-line text-muted">
          {intl.formatMessage({ id: "reset_success_message" })}
        </div>
      )}
      <div className="text-center mt-1">
        <Link to={RouteConstants.APP_ROUTE_LOGIN}>
          {intl.formatMessage({ id: "back_to_login" })}
        </Link>
      </div>
    </PreLoginContainer>
  );
};

const mapStateToProps = (state) => ({
  requesting: state.auth.requesting,
  error: state.auth.error,
  action: state.auth.action,
});

const mapDispatchToProps = (dispatch) => ({
  resetPasswordRequest: (data) => dispatch(resetPasswordRequest(data)),
  resetState: () => dispatch(resetState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SetPassword);
